// agent-experience-redesign-v1.md (post-shipping clarification 2026-04-30):
// platform-managed agents (Super Agent / Platform Tester / Orchestrator)
// carry IP-sensitive system prompts + flow_configs that we don't want
// tenants editing. They're surfaced in Detail Viewer as a stripped-
// down config card with ONLY provider + model editable; all other
// tabs hidden; "Open in Builder" hidden.
//
// Three flags are recognized today:
//   metadata_json.is_super_agent      — Agent Builder Super Agent
//                                        (the "Create with AI" engine)
//   metadata_json.is_platform_tester  — Platform Tester (QA agent)
//   metadata_json.is_self_assembling  — Orchestrator (meta-agent that
//                                        plans + spawns ephemeral agents)
//
// Future flags can be added here without touching every consumer site.

const FLAGS = ["is_super_agent", "is_platform_tester", "is_self_assembling"];

/**
 * Returns true if this agent is platform-managed and should render
 * in locked-down mode. Robust to missing metadata_json.
 */
export function isPlatformManagedAgent(agent) {
  if (!agent) return false;
  const meta = agent.metadata_json || {};
  return FLAGS.some((f) => meta[f] === true);
}

/**
 * Human-readable label for the kind of platform-managed agent.
 * Returns null if not platform-managed.
 */
export function platformManagedKind(agent) {
  if (!agent) return null;
  const meta = agent.metadata_json || {};
  if (meta.is_super_agent)     return "Agent Builder · Create with AI";
  if (meta.is_platform_tester) return "Platform Tester";
  if (meta.is_self_assembling) return "Orchestrator";
  return null;
}

/**
 * Short user-facing description of what each kind is for.
 */
export function platformManagedDescription(agent) {
  if (!agent) return "";
  const meta = agent.metadata_json || {};
  if (meta.is_super_agent) {
    return "Powers the \"Create with AI\" flow — generates new agents from natural-language descriptions. Bring your own LLM provider; the agent's logic itself is platform-managed.";
  }
  if (meta.is_platform_tester) {
    return "Runs scripted QA across the platform — agents, channels, integrations. Bring your own LLM; scripts are platform-managed.";
  }
  if (meta.is_self_assembling) {
    return "Plans complex tasks dynamically by spawning short-lived helper agents. Bring your own LLM; orchestration logic is platform-managed.";
  }
  return "";
}
